<template>
  <div class="realtime-btn-list">
    <el-button type="primary" @click="showDialogSearchTable('first')">
      <img src="@/assets/img/icon03.png" style="width: 14px; margin-right: 5px;"/>
      查询
    </el-button>
    <el-button type="primary" @click="openSetting">
      <img src="@/assets/img/icon02.png" style="width: 14px; margin-right: 5px;"/>
      设置
    </el-button>
    <el-button type="primary" @click="refresh">
      <img src="@/assets/img/icon01.png" style="width: 14px; margin-right: 5px;"/>
      刷新
    </el-button>
    <el-button type="primary" @click="showEquipmentTable = true">
      <img src="@/assets/img/icon04.png" style="width: 14px; margin-right: 5px;"/>
      设备
    </el-button>
    <el-form :inline="true" label-width="0" class="spotCountLine">
      <el-form-item>
        <el-input placeholder="请输入内容" v-model.number="ParkLotDetail.SpotCount" style="width: 110px;" disabled>
          <template slot="prepend">总车位</template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="余位" v-model.number="SpotCanUseCount" style="width: 110px;">
          <template slot="prepend">余位</template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitSpotCanUseNum">确 定</el-button>
      </el-form-item>
    </el-form>
    <dialog-search-table
      :showdialog.sync="showSearchTable"
      :activeName="showSearchTableIndex"
    />
    <dialog-handle-in v-if="showHandleIn" :showdialog.sync="showHandleIn" />
    <dialog-setting :showdialog.sync="showSetting" :form="formData" />
    <dialog-handle-out v-if="showHandleOut" :showdialog.sync="showHandleOut" :title="'手动关闸'"></dialog-handle-out>
    <dialog-handle-table-out
      title="出入口选择"
      v-if="showHandleTableOut"
      :showdialog.sync="showHandleTableOut"
      @getOutGateId="confirmOpenGate"
    ></dialog-handle-table-out>
    <el-dialog
      :visible.sync="showSpotCanUseNum"
      width="30%"
      center>
      <el-form :inline="true" label-width="60px">
        <el-form-item label="总车位">
          <el-input v-model.number="ParkLotDetail.SpotCount" disabled></el-input>
        </el-form-item>
        <el-form-item label="余位">
          <el-input v-model.number="SpotCanUseCount"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSpotCanUseNum = false">取 消</el-button>
        <el-button type="primary" @click="submitSpotCanUseNum">确 定</el-button>
      </span>
    </el-dialog>
    <dialog-equipment-table
      v-if="showEquipmentTable"
      :showdialog.sync="showEquipmentTable"
    ></dialog-equipment-table>
  </div>
</template>

<script>
//场内查询 出场查询 收费查询 弹窗
import dialogSearchTable from "@/serviceComponents/dialogSearchTable";
//输入车牌号码入场  弹窗
import dialogHandleIn from "@/serviceComponents/dialogHandleIn";
// 设置
import dialogSetting from "@/serviceComponents/dialogSetting";
//免费开闸  取消出场 弹窗
import dialogHandleOut from "@/serviceComponents/dialogHandleOut";
import dialogHandleTableOut from "@/serviceComponents/dialogHandleTableOut";
import dialogEquipmentTable from "@/serviceComponents/dialogEquipmentTable";
import { getChargingPopUp } from "@/utils/service";

import {
  parkOrderListPubSub,
  spotNumPubSub,
} from "@/service/pubsub/index";

import { getTenantId } from "@/utils/service";

import { curlSentryUserConfig } from "@/api/module/tenant";
import { setSpotCanUseNum, queryParkLotDetailById } from "@/api/module/park";

export default {
  components: {
    dialogSearchTable,
    dialogHandleIn,
    dialogSetting,
    dialogHandleOut,
    dialogHandleTableOut,
    dialogEquipmentTable,
  },
  data() {
    return {
      showSearchTable: false,
      showSearchTableTitle: undefined,
      showSearchTableIndex: "first",
      showHandleIn: false,
      showSetting: false,
      formData: {},
      showHandleOut: false,
      showHandleTableOut: false,
      TenantId: null,
      showSpotCanUseNum: false,
      ParkLotDetail: {
        SpotCount: undefined
      },
      SpotCanUseCount: undefined,
      showEquipmentTable: false,
    }
  },
  computed: {
    gateId: function () {
      let arr = this.$store.state.order.gateIds ? this.$store.state.order.gateIds : [];
      let id = arr[0] ? arr[0].Id : undefined;
      return id;
    },
    showArrearsDialog: function () {
      return this.$store.state.layout.showArrearsDialog
    },
    ParkLotId:function(){
      return this.$store.state.order.parkLotId
    },
    noticeSortStr: function () {
      return this.$store.state.order.noticeSortStr;
    },
    gateIds: function () {
      return this.$store.state.order.gateIds;
    },
    settingConfig: function () {
      return JSON.stringify(this.$store.state.layout.settingConfig) === '{}' ? JSON.parse(getChargingPopUp()) : this.$store.state.layout.settingConfig;
    },
    isManager:function(){
      return this.$store.state.user.isManager;
    },
  },
  watch: {
    showArrearsDialog(v) {
      if (v) {
        this.showDialogSearchTable('third', true)
      }
    },
    $route: {
      handler: function(){
        // console.log('$route')
        if (this.settingConfig) this.settingConfig.ChargeBullet = 0;
        this.$store.dispatch("SetSettingConfig", this.settingConfig);
        this.getSpotCanUseNum();
        this.getSetting();
      },
      deep: true
    },
    noticeSortStr() {
      this.getSetting();
      this.showSetting = false;
    },
  },
  mounted() {
    this.TenantId = parseInt(getTenantId());
    parkOrderListPubSub.subscribe(this.getGateId);
    this.$store.dispatch("SetSettingConfig", {});
    this.getSetting();
    this.getSpotCanUseNum();
    spotNumPubSub.unsubscribe();
    spotNumPubSub.subscribe(this.getSpotNum);
  },
  methods:{
    showDialogSearchTable(type, bool) {
      this.showSearchTableIndex = type;
      if (bool) {
        this.$store.dispatch("SetPubOutGateId", '');
      }
      this.showSearchTable = true;
    },
    showDialogHandleOutIn(key) {
      this[key] = true;
    },
    openSetting() {
      this.getSetting();
      this.showSetting = true;
    },
    getSetting() {
      let param = {SentryId: Number(sessionStorage.getItem("sentryId"))};
      param.TenantId = this.isManager ? this.TenantId : undefined;
      curlSentryUserConfig(param).then((res) => {
        if (res.state === "success") {
          let setConfig = {
            BulletFrame: res.data.BulletFrame,
            EditCarType: res.data.EditCarType,
            ShowCodeGun: res.data.ShowCodeGun,
            FreeOrderShow: res.data.FreeOrderShow,
            ChargeList: [],
            ChargeButton: [],
            LockGate: res.data.LockGate,
            ShowPassIn: res.data.ShowPassIn,
            SentryStatFields: [],
            ChargeBullet: res.data.ChargeBullet,
            BulletPlateColor: res.data.BulletPlateColor,
            BulletPlateSize: res.data.BulletPlateSize,
            MyField: [],
            ShowVideo: res.data.ShowVideo,
            ShowStatistics: res.data.ShowStatistics,
          };
          this.formData = {
            BulletFrame: res.data.BulletFrame,
            ChargeFieldsArr: res.data.ChargeFields !== '' ? res.data.ChargeFields.split(',') : [],
            ChargeFieldList: res.data.ChargeFieldList,
            ChargeButtonList: res.data.ChargeButtonList,
            ChargeButtonArr: res.data.ButtonFields !== '' ? res.data.ButtonFields.split(',') : [],
            EditCarType: res.data.EditCarType,
            ShowCodeGun: res.data.ShowCodeGun,
            FreeOrderShow: res.data.FreeOrderShow,
            LockGate: res.data.LockGate,
            ShowPassIn: res.data.ShowPassIn,
            SentryStatFieldsArr: res.data.SentryStatFields !== '' ? res.data.SentryStatFields.split(',') : [],
            SentryStatFieldsList: res.data.SentryStatFieldList,
            sortSentryStatFields: [],
            ChargeBullet: res.data.ChargeBullet,
            BulletPlateColor: res.data.BulletPlateColor,
            BulletPlateSize: res.data.BulletPlateSize,
            MyFieldList: res.data.MyFieldList,
            MyFieldArr: res.data.MyFields !== '' ? res.data.MyFields.split(',') : [],
            ShowVideo: res.data.ShowVideo,
            ShowStatistics: res.data.ShowStatistics,
          };
          if (res.data.ChargeFieldList) {
            setConfig.ChargeList = res.data.ChargeFieldList.filter(v => {return v.Selected}).map(v => {return v.Key});
          }
          if (res.data.ChargeButtonList) {
            setConfig.ChargeButton = res.data.ChargeButtonList.filter(v => {return v.Selected}).map(v => {return v.Key});
          }
          if (res.data.SentryStatFieldList) {
            setConfig.SentryStatFields = this.formData.SentryStatFieldsArr.map(v => {
              let arr = res.data.SentryStatFieldList.filter(vv => {
                return vv.Value === v
              });
              this.formData.sortSentryStatFields.push(arr[0]);
              return arr[0].Key
            })
          }
          if (res.data.MyFieldList) {
            setConfig.MyField = res.data.MyFieldList.filter(v => {return v.Selected}).map(v => {return v.Key});
          }
          localStorage.setItem('frameStyle', res.data.BulletFrame);
          this.$store.dispatch("SetSettingConfig", setConfig);
        }
      })
    },
    refresh() {
      location.reload()
    },
    getGateId(gateId) {
      this.$store.dispatch("SetPubOutGateId", gateId);
      // console.log('getGateId', this.$store.state.order.pubOutGateId);
      this.showDialogSearchTable('third');
    },
   getSpotCanUseNum() {
      queryParkLotDetailById({ParkLotId: this.ParkLotId}).then(res => {
        if (res.state === "success") {
          this.ParkLotDetail = res.data;
          this.SpotCanUseCount = res.data.SpotCanUseCount;
          sessionStorage.setItem('FreeTempOrderConfirm', res.data.FreeTempOrderConfirm)
          // console.log('setSpotCanUseNum', res.data)
          // this.showSpotCanUseNum = true;
        } else {
          this.$message.error(res.message);
        }
      })
    },
    submitSpotCanUseNum() {
      setSpotCanUseNum({Id: this.ParkLotId, SpotCanUseCount: this.SpotCanUseCount}).then(res => {
        if (res.state === "success") {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      })
    },
    getSpotNum(data) {
      // console.log(data);
      this.SpotCanUseCount = data
    },
  }
};
</script>

<style lang="scss">
  .spotCountLine{
    .el-input-group__prepend{
      padding-left: 5px;
      padding-right: 5px;
    }
    .el-input__inner{
      height: 35px;
    }
  }
</style>
